export class Topic {
  private static _values: Topic[] = [];
  private static _lookup: Map<number, Topic> = new Map();

  static fromBlank() {
    return Topic.fromId(0);
  }

  static fromId(id: number) {
    const topic = Topic._lookup.get(id);
    if (topic === undefined) {
      throw new Error('Not a valid Topic.id: ' + id);
    }
    return topic;
  }

  static values(): Topic[] {
    return [...Topic._values];
  }

  // ---

  readonly id: number;
  readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Topic._values.push(this);
    Topic._lookup.set(id, this);
  }

  get isSet() {
    return this.id !== 0;
  }

  get isBlank() {
    return this.id === 0;
  }

  toJson() {
    return { id: this.id, name: this.label };
  }

  toString() {
    return '<Topic: id=' + this.id + ', label=' + this.label + '>';
  }
}

/**
 * Configure the Topics in-memory from a list of preloaded topics.
 *
 * @param data Preloaded topics data
 */
export const configureTopics = (data: any[]): void => {
  for (const item of data) {
    new Topic(item.id, item.name);
  }
};
